export default {
  subscriptions: [],
  overview: { total_enable: {}, total_past_due: {}, total_disable: {} },
  pagination: {}
};
